<template>
    <div class="flex items-end gap-x-0.5">
        <p v-text="whisperText" class="text-text-muted italic" />
        <div
            class="flex justify-center items-center pb-[5px] gap-x-[1.5px] opacity-80"
        >
            <div
                class="size-1.5 bg-text-muted rounded-full animate-bounce-lg [animation-delay:-0.3s]"
            />
            <div
                class="size-1.5 bg-text-muted rounded-full animate-bounce-lg [animation-delay:-0.15s]"
            />
            <div
                class="size-1.5 bg-text-muted rounded-full animate-bounce-lg"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'WhisperText',

    props: {
        whisperText: {
            type: String,
            required: true,
        },
    },
}
</script>
